//=============================================================================
//=============================================================================
// utils
//=============================================================================
//=============================================================================
import $ from "jquery";
import * as _ from "./voidash";

const dummyDiv = /*@__PURE__*/document.createElement("div");

function emptyElement(el) {
  while(el.childNodes.length) el.removeChild(el.lastChild);
}

export function htmlEntities(str) {
  dummyDiv.innerText = str;
  const innerHTML = dummyDiv.innerHTML;
  emptyElement(dummyDiv);
  return innerHTML.replace(/<br[^>]*?>/g, "\n");
  /*return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');*/
}

export function decodeQueryString(qs) {
  if (qs[0] === "?") qs = qs.substring(1);
  const params = qs.split("&");
  const out = {};
  for (const item of params) {
    if (!item) continue;
    const pair = item.split('=');
    out[pair[0]] = decodeURIComponent(pair[1]);
  }
  return out;
}

export function encodeQueryString(obj) {
  const out = [];
  for (const key of _.keys(obj)) {
    if (obj[key] === true) out.push(key);
    else out.push(key + '=' + encodeURIComponent(obj[key]));
  }

  return "?" + out.join('&');
}

export function toggleClass(el, className, state) {
  if(typeof el === "string") el = "#" + el;
  $(el).toggleClass(className, state);
}

export function setObject(obj, path, value) {
  let i = 0;
  for(; i < path.length - 1; i++) {
    const pathElement = path[i];
    if(obj.hasOwnProperty(pathElement)) obj = obj[pathElement];
    else obj[pathElement] = obj = {};
  }

  obj[path[i]] = value;
}

/*function getObject(obj, path) {
  for(var i = 0; i < path.length; i++) {
    var pathElement = path[i];
    if(obj.hasOwnProperty(pathElement)) obj = obj[pathElement];
    else obj[pathElement] = obj = {};
  }

  return obj;
}*/

export function getElement(el) {
  return typeof el === "string" ? document.getElementById(el) : el;
}

export var isStandalone = false;

try {
  isStandalone = window.matchMedia('(display-mode: standalone)').matches;
} catch(e) {
  console.log(e);
}

if(!isStandalone) isStandalone = !!window.navigator.standalone;

export const uid = (function() {
  const uids = {};

  return function uid(prefix) {
    if(!uids.hasOwnProperty(prefix)) uids[prefix] = 0;
    return prefix + "_" + ++uids[prefix];
  }
})();

export function insertHTMLBefore(html, ref) {
  let node = ref;

  if(node.nodeType !== Node.ELEMENT_NODE) {
    node = document.createElement("div");
    ref.parentNode.insertBefore(node, ref);
  }

  node.insertAdjacentHTML("beforebegin", html);

  if(node !== ref) node.parentNode.removeChild(node);
}

export const COMPLETE_ALT_RE = /\[\[ALT\[\[(.*?)]]ALT\[\[(.*?)]]ALT]]/g;
export function translateAltString(str, alternative) {
  if (typeof str !== "string") return str;
  return str.replace(COMPLETE_ALT_RE, (match, ...args) => args[alternative]);
}

export function closest(node, pred) {
  while (node) {
    if (pred(node)) return node;
    node = node.parentNode;
  }
  return null;
}
